'use client';

import { useEffect } from 'react';

export default function ErrorPage({ error }: { error: Error }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Error from @tabs route:', error);
  }, [error]);
  return null;
}
